var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8864_52818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 12.8008,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1 13.5078C28.0421 13.5078 21.5094 20.0407 21.5094 28.099C21.5094 36.1572 28.0421 42.6901 36.1 42.6901C44.158 42.6901 50.6906 36.1572 50.6906 28.099C50.6906 20.0407 44.158 13.5078 36.1 13.5078ZM34.0102 35.4369C27.8589 31.3248 20.9838 23.7395 26.3623 18.3608C31.7407 12.9822 40.4593 12.9822 45.8378 18.3608C50.2074 22.7306 50.7078 29.1662 48.2951 34.5037C46.8787 37.6367 40.3334 39.6636 34.0102 35.4369Z",
    fill: "#FBC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.334 31.0042V23.7632H33.1647V31.0042H31.334ZM28.6289 28.299V26.4684H35.8698V28.299H28.6289ZM42.4042 22.1269V32.5996H40.19V24.2286H40.1287L37.7304 25.732V23.7684L40.323 22.1269H42.4042Z",
    fill: "#DD9700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8864_52818",
    x: 0.799988,
    y: 0.800781,
    width: 70.4,
    height: 70.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.768627 0 0 0 0 0.301961 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8864_52818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8864_52818",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints1);
export default __webpack_public_path__ + "static/media/Points_1.42f78671cfe5eb7141a0af8e3d3418e4.svg";
export { ForwardRef as ReactComponent };